import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";

const links = [
  { href: "#about", label: "About", testid: "nav-link-about" },
  { href: "#services", label: "Services", testid: "nav-link-services" },
  { href: "#approach", label: "Credentials", testid: "nav-link-credentials" },
  { href: "#contact", label: "Contact", testid: "nav-link-contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-[#E3DCD3]/60 bg-[#FAF8F5]/80 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-6 sm:px-8 lg:px-12">
        <a href="#top" data-testid="header-logo" className="flex items-baseline gap-2.5">
          <span className="font-serif text-2xl font-medium tracking-tight text-[#2C2825]">Simran Kaur</span>
          <span className="hidden font-mono text-[10px] uppercase tracking-[0.22em] text-[#8C827A] sm:inline">
            NCPS · Psychotherapy
          </span>
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-sm text-[#5E564F] transition-colors duration-300 hover:text-[#2C2825]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="header-book-cta"
            className="inline-flex items-center gap-1.5 rounded-full bg-[#2C2825] px-5 py-2.5 text-sm font-medium text-[#FAF8F5] transition-colors duration-300 hover:bg-[#C46B4E]"
          >
            Book consultation
            <ArrowUpRight className="h-3.5 w-3.5" />
          </a>
        </nav>
        <button
          data-testid="mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="p-2 text-[#2C2825] md:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      {open && (
        <div className="flex flex-col gap-4 border-t border-[#E3DCD3]/60 bg-[#FAF8F5] px-6 py-5 md:hidden" data-testid="mobile-menu">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-base text-[#2C2825]">
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="inline-flex w-fit items-center gap-1.5 rounded-full bg-[#2C2825] px-5 py-2.5 text-sm font-medium text-[#FAF8F5]"
          >
            Book consultation
            <ArrowUpRight className="h-3.5 w-3.5" />
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
